import './../grouped_elements/grouped_elements_select_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.TagsFilterGroupView extends Monitoring.Views.SocialContents.Filters.GroupedElementsSelectView
  hierarchyTemplate: JST['backbone/templates/monitoring/social_contents/tags_editor/tags_hierarchy']

  events: =>
    return _.extend({}, Monitoring.Views.SocialContents.Filters.GroupedElementsSelectView.prototype.events, {
      'click .show-hierarchy': 'showHierarchy'
    })

  initialize: ({id, possibleElements, appliedElements, title, logic, canFilterOnlyPresent, useKeepconModal, includeAlternativeTaxonomies}) ->
    @useKeepconModal = useKeepconModal
    @includeAlternativeTaxonomies = includeAlternativeTaxonomies
    super({id, possibleElements, appliedElements, title, logic, canFilterOnlyPresent})

  render : ->
    super
    @_renderHierarchy()
    @

  _renderHierarchy: () ->
    @$el.find('#selector .header').append(@_showHierarchyButton())
    @$el.find('#selector .header #hierarchy-modal').html(@hierarchyTemplate(alternativeTaxonomies: false))

  _showHierarchyButton: () ->
    visibilityClass = if @mustHideHierarchy() then 'hidden' else ''
    "<div class='btn btn-primary show-hierarchy label #{ visibilityClass }' style='margin-top:0;'>" +
     "<i class='fa fa-sitemap'></i> #{I18n.t('customer.dashboard.filters.creation.tags.tree_view')}</div>"

  showHierarchy: ->
    unless @codeToDescription
      @codeToDescription = {}
      _.each(@possibleElements, (element) => @codeToDescription[element.term] = element.description)
    @_createHierarchyView()

  _createHierarchyView: ->
    if @useKeepconModal then @_keepconModalHierarchy() else @_bootstrapModalHierarchy()
    @listenTo(@tagsHierarchyView, 'selected:tags', @onChangeTagsFromHierarchy)

  _bootstrapModalHierarchy: ->
    @tagsHierarchyView = new Monitoring.Views.Dashboards.TagsHierarchyModalView(@_hierarchyViewArguments())
    @$el.append(@tagsHierarchyView.render().el)
    @showModal()

  _keepconModalHierarchy: ->
    @tagsHierarchyView = new Monitoring.Views.Dashboards.TagsHierarchyKeepconModalView(@_hierarchyViewArguments())
    @tagsHierarchyView.render()

  _hierarchyViewArguments: ->
    firstLevelNodes: Keepcon.currentAccount.hierarchy.root.children
    currentTags: _.pluck(@appliedElements, 'term')
    translator: @codeToDescription
    includeAlternativeTaxonomies: @includeAlternativeTaxonomies

  onChangeTagsFromHierarchy: (newTagsCodes) ->
    @hideModal()
    @appliedElements = _.filter(@possibleElements, (tag) -> tag.applied = _.contains(newTagsCodes, tag.term))
    setTimeout =>
      @render()
    , 500

  checkboxClass: ->
    'tags-checkbox-label'

  checkboxLabel: ->
    I18n.t('monitoring.dashboard.filters.exclusion_label')

  comboPlaceholder: ->
    I18n.t('customer.dashboard.filters.placeholders.add_tag')

  possibleCustomNames: () ->
    ['allTags', 'noTags']

  _swalTitle: () ->
    I18n.t('customer.dashboard.filters.creation.tags.add_warning')

  mustHideHierarchy: ->
    @disabled or not Keepcon.currentAccount.hierarchy?

  showModal: =>
    @$el.find('#tags-hierarchy-modal').modal('show')

  hideModal: =>
    @$el.find('#tags-hierarchy-modal').modal('hide')
